// Categorias disponíveis no GetNinjas
export const allCategories = [
  'Pedreiro',
  'Diarista',
  'Montador de Móveis',
  'Eletricista',
  'Mudanças e Carretos',
  'Encanador',
  'Pintor',
  'Marido de Aluguel',
  'Marceneiro',
  'Psicólogo',
  'Empreiteiro',
  'Gesso e Drywall',
  'Segurança Eletrônica',
  'Buffet Completo',
  'Serralheria e Solda',
  'Televisão',
  'Instalação e Reparo',
  'Fretes',
  'Calheiro',
  'Instalação',
  'Arquiteto',
  'Alvenaria',
  'Mudanças',
  'Jardinagem',
  'Depilação',
  'Chaveiro',
  'Cabelos e Maquiagem',
  'Professor',
  'Vidraceiro',
  'Desentupidor',
  'Móveis Planejados',
  'Enfermagem',
  'Instalação de Vidros e Espelhos',
  'Limpeza Pós-Obra',
  'Cervejeiro',
  'Limpeza de Sofás',
  'Organização de Ambientes',
  'Fotografia',
  'Lavanderia',
  'Climatização',
  'Tosa e Banho',
  'Enfestador',
  'Desenvolvimento de Aplicativos',
  'Assistência Técnica para Celular',
  'Paisagista',
  'Montagem e Desmontagem',
  'Mudanças Internacionais',
  'Instalação de Máquinas',
  'Mecânico',
  'Diarista para Escritório',
  'Essências e Perfumes',
  'Limpeza de Carpetes',
  'Personal Organizer',
  'Assistente Pessoal',
  'Assessoria de Eventos',
  'Confeiteiro',
  'Nutricionista',
  'Pintura Industrial',
  'Instalação de Calhas e Rufos',
  'Confecção',
  'Barbeiro',
  'Instrumento Musical',
  'Monitor de Ativos',
  'Carpintaria',
  'Marmoraria e Granitos',
  'Cuidador de Pessoas',
  'Desenvolvimento de Sites e Sistemas',
  'Gás',
  'Contador',
  'Bem-Estar',
  'Dedetizador',
  'Marketing Online',
  'Restauração e Polimento de Pisos',
  'Babá',
  'Psicanalista',
  'Manicure e Pedicure',
  'Fisioterapeuta',
  'Pesquisas em Geral',
  'Áudio e Vídeo',
  'DJs',
].sort();
